// extracted by mini-css-extract-plugin
export default {"colorBox":"styles_colorBox__pZ8wm"};